module.exports = __webpack_public_path__ + "static/media/logo.c6176fdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.svg
// module id = 985
// module chunks = 0